module.exports = __webpack_public_path__ + "img/icon_gender.e97953c5.svg";